import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../../webcomponents.constants';
import { ExchangeProtectionDataProvider } from '../dataProvider/ExchangeProtectionDataProvider';

export class ExchangeProtectionDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, ExchangeProtectionDataProvider);
  }
}
